import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackModalComponent } from '../../student-voice/feedback-modal/feedback-modal.component';
import { FeedbackSurvey } from '../../_models/student-feedback/feedback-survey.model';

@Injectable({
  providedIn: 'root'
})
export class StudentFeedbackRequiredHelperService {

  constructor(public dialog: MatDialog) { }
  
  public showStudentFeedbackRequiredModal(survey: FeedbackSurvey): void {
    const dialogRef = this.dialog.open(FeedbackModalComponent, {
      data: { 
        feedbackSurvey: survey,
        showHeaderText: true 
      },
      panelClass: 'my-dialog',
      disableClose: true
    });
  }

}
